const regexCache = new Map<string, RegExp>();

function getRegex(pattern: string, flags: string): RegExp | null {
    const key = `${flags}:${pattern}`;
    let regex = regexCache.get(key);

    if (!regex) {
        try {
            regex = new RegExp(pattern, flags);
            regexCache.set(key, regex);
        } catch {
            console.warn(`Invalid regex pattern: ${pattern}`);
            return null;
        }
    }

    return regex;
}

function match(find: string, patterns: string | readonly string[], flags: string = ''): boolean {
    const normalizedPatterns = Array.isArray(patterns) ? patterns : [patterns];

    for (const pattern of normalizedPatterns) {
        const regex = getRegex(pattern, flags);

        if (regex?.test(find)) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

export default match;
